import assetIcFlashWarning from './ic-flash-warning.svg';
export enum ErrorBoundaryIconName {
  FlashWarning = 'FlashWarning',
}

export const errorPageInlineIconAssets: {
  [key in ErrorBoundaryIconName]: string;
} = {
  [ErrorBoundaryIconName.FlashWarning]: assetIcFlashWarning,
};
